import * as React from "react";

export default class InlineSVG extends React.Component {
	static defaultProps = {
		className: "",
		src: "",
	};

	constructor(props) {
		super(props);
		this.state = {
			client: false,
		};
	}

	componentDidMount() {
		if (!this.state.client) {
			this.updateComponent();
		}
	}

	updateComponent() {
		this.setState({
			client: true,
		});
	}

	renderContent() {
		if (typeof window === "undefined") {
			return null;
		}

		if (!this.state.client) {
			return null;
		}

		let SVG = null;
		if (!window.svgInlineModuleInstance) {
			window.svgInlineModuleInstance = require("react-inlinesvg").default;
		}

		SVG = window.svgInlineModuleInstance;

		if (!SVG) {
			return null;
		}
		return (
			<SVG
				className={this.props.classNameSVG}
				preloader={<div />}
				wrapper={React.createFactory("div")}
				uniqueHash={"1"}
				cacheGetRequests={true}
				uniquifyIDs={true}
				src={this.props.src}
			>
				{this.props.children}
			</SVG>
		);
	}

	render() {
		return <div className={this.props.className}>{this.renderContent()}</div>;
	}
}
